import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const Review = ({ children }) => (
  <div className="flex size-10 items-center justify-center gap-x-1">
    <Icon
      className="text-experimental-blue dark:text-experimental-blue"
      name="rating-star"
    />
    <Text
      as="span"
      className="text-experimental-blue dark:text-experimental-blue"
      size="size2"
      type="primary"
      bold
    >
      {children}
    </Text>
  </div>
);

Review.propTypes = {
  children: PropTypes.number.isRequired,
};

export default Review;
